<template>
  <div class="page-container">
    <!-- <container-left> -->
    <!-- <slot name="pageLeft"></slot> -->
    <!-- </container-left> -->
    <container-right :class="{ 'ml-200px': ml }">
      <slot name="pageRight"> </slot>
    </container-right>
  </div>
</template>
<script>
import { ContainerLeft, ContainerRight } from '@/components'
export default {
  components: { ContainerLeft, ContainerRight },
  props: {
    ml: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      lang: 'zh'
    }
  },
  mounted() {
    this.lang = this.$ls.get('lang');
  }
}
</script>
<style>
.el-loading-mask {
  z-index: 3;
}
</style>
<style lang="less" scoped>
.page-container {
  display: flex;
  // margin-top: 25px;
  .ml-200px {
    margin-left: 200px;
  }
}
</style>
